import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {
    TableRow,
    TableRowColumn
} from 'material-ui/Table';
import FuseTheme from '../global/theme';
import IconButton from 'material-ui/IconButton';
import ContentCreate from 'material-ui/svg-icons/content/create';
import ContentDelete from 'material-ui/svg-icons/action/delete';
import ContentView from 'material-ui/svg-icons/image/remove-red-eye';

/**
 * Adds inline content for default units
 *
 * @param data
 * @return {string}
 */
const isDefault = (data) => {
    if (data.default_unit && data.default_unit === true) {
        return ' (Default)'
    }
    return ''
};

/**
 * Display Default Price if it exists
 * @param data
 * @return {*}
 */
const showPrice = (data) => {
    if (data.price && data.price.default) {
        return data.price.default
    }
    return '(none)'
};

const styles = {
    rowHeight: {height: '40px'},
    icon: {height: '40px', padding: '10px', overflow: 'inherit'}
};

const ProductUnitTableRow = ({basePath, data, showDelete = false, showEdit = false, showView = false}) => (
    <TableRow style={styles.rowHeight}>
        <TableRowColumn style={styles.rowHeight}>
            {data.id}
        </TableRowColumn>
        <TableRowColumn style={styles.rowHeight}>
            {data.name}
        </TableRowColumn>
        <TableRowColumn style={styles.rowHeight}>
            {data.unit_type}{isDefault(data)}
        </TableRowColumn>
        <TableRowColumn style={styles.rowHeight}>
            {showPrice(data)}
        </TableRowColumn>

        {showView &&
        <TableRowColumn style={styles.rowHeight}>
            <IconButton
                containerElement={<Link to={`${basePath}/${encodeURIComponent(data.type)}/${data.id}/show`}/>}
                style={styles.icon}>
                <ContentView color={FuseTheme.palette.primary1Color}/>
            </IconButton>
        </TableRowColumn>
        }
        {showEdit &&
        <TableRowColumn style={styles.rowHeight}>
            <IconButton
                containerElement={<Link to={`${basePath}/${encodeURIComponent(data.type)}/${data.id}`}/>}
                style={styles.icon}>
                <ContentCreate color={FuseTheme.palette.primary1Color}/>
            </IconButton>
        </TableRowColumn>
        }
        {showDelete &&
        <TableRowColumn style={styles.rowHeight}>
            <IconButton
                containerElement={<Link to={`${basePath}/${encodeURIComponent(data.type)}/${data.id}/delete`}/>}
                style={styles.icon}>
                <ContentDelete color={FuseTheme.palette.primary1Color}/>
            </IconButton>
        </TableRowColumn>
        }
    </TableRow>
);

ProductUnitTableRow.propTypes = {
    basePath: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    showDelete: PropTypes.bool,
    showEdit: PropTypes.bool,
    showView: PropTypes.bool,
};

ProductUnitTableRow.defaultProps = {
    style: {padding: 0},
};

export default ProductUnitTableRow;


// WEBPACK FOOTER //
// ./src/Fuse/components/ProductUnitTableRow.js